export function getSalesDiscountChartData({
  objects,
  selectedStoreCode,
  selectedMonthName,
  selectedYear,
}) {
  const filtered = (objects || [])
    .filter((o) => o.status === "C")
    .filter((sale) => {
      const date = new Date(sale.tran_date);
      const year = date.getFullYear();
      const month = date.toLocaleString("default", { month: "long" });
      const store = sale.store_code.replace("ANGELSPIZZA_", "");

      const okYear = selectedYear ? year === parseInt(selectedYear, 10) : true;
      const okMonth = selectedMonthName ? month === selectedMonthName : true;
      const okStore = selectedStoreCode ? store === selectedStoreCode : true;
      return okYear && okMonth && okStore;
    });

  const now = new Date();
  const monthsToShow = 12;
  const labels = [];
  const salesData = [];
  const discountData = [];

  for (let i = monthsToShow - 1; i >= 0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const m = d.getMonth(),
      y = d.getFullYear();

    const monthTx = filtered.filter((tx) => {
      const txDate = new Date(tx.tran_date);
      return txDate.getMonth() === m && txDate.getFullYear() === y;
    });

    if (monthTx.length) {
      let monthSales = 0,
        monthDiscounts = 0;
      monthTx.forEach((tx) => {
        const total = Number(tx.total || 0);
        const discount = Number(tx.discount_amount || 0);
        const tax = Number(tx.total_tax || 0);
        monthSales += total - tax;
        monthDiscounts += discount;
      });

      labels.push(
        d.toLocaleString("default", { month: "long", year: "numeric" })
      );
      salesData.push(monthSales);
      discountData.push(monthDiscounts);
    }
  }

  return {
    labels,
    datasets: [
      {
        label: "Sales",
        data: salesData,
        borderColor: "#1b74bb",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
        fill: true,
      },
      {
        label: "Discount Amount",
        data: discountData,
        borderColor: "rgb(255, 205, 86)",
        backgroundColor: "rgba(255, 205, 86, 0.5)",
        fill: true,
      },
    ],
  };
}

/**
 * Build the Chart.js “options” object for your stacked bar chart.
 * @returns {Object}
 */
export function getSalesDiscountChartOptions() {
  return {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text: "Sales vs. Discounts (Last 12 Months)",
      },
    },
    scales: {
      x: { stacked: true },
      y: { stacked: true },
    },
  };
}
